'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-130a177d.js');
var React = require('react');
var styled = require('styled-components');
var browser_utils = require('../browser.utils-bfcc05c6.js');
require('../viewport.utils-0c2b4e2b.js');
var Icons_StarIcon_index = require('../Icons/StarIcon/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var StarsWrapper = styled__default['default'].div.withConfig({ displayName: "ww-uikit_StarsWrapper_locmlsml", componentId: "sc-14uzxpc" })(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    display: grid;\n    grid-gap: 6px;\n    grid-template-columns: repeat(5, ", "px);\n    color: ", ";\n    margin: 20px 0 30px;\n    height: ", "px;\n\n    &[data-type='editable'] {\n        cursor: pointer;\n    }\n\n    ", "\n"], ["\n    display: grid;\n    grid-gap: 6px;\n    grid-template-columns: repeat(5, ", "px);\n    color: ", ";\n    margin: 20px 0 30px;\n    height: ", "px;\n\n    &[data-type='editable'] {\n        cursor: pointer;\n    }\n\n    ",
    "\n"])), function (_a) {
    var starSize = _a.starSize;
    return starSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.yellow100;
}, function (_a) {
    var starSize = _a.starSize;
    return starSize;
}, browser_utils.forIE(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n        display: flex;\n    "], ["\n        display: flex;\n    "]))));

(function (StarState) {
    StarState["EMPTY"] = "EMPTY";
    StarState["FILLED"] = "FILLED";
    StarState["HALF_FILLED"] = "HALF_FILLED";
})(exports.StarState || (exports.StarState = {}));
var roundScore = function (score) {
    var decimal = score % 1;
    if (decimal <= 0.25) {
        return Math.floor(score);
    }
    if (decimal >= 0.75) {
        return Math.ceil(score);
    }
    return Math.trunc(score) + 0.5;
};
var Star = function (_a) {
    var starState = _a.starState, testId = _a.testId, starProps = tslib_es6.__rest(_a, ["starState", "testId"]);
    if (starState === exports.StarState.EMPTY) {
        return (React__default['default'].createElement("div", tslib_es6.__assign({ "data-testid": testId + "_" + exports.StarState.EMPTY }, starProps),
            React__default['default'].createElement(Icons_StarIcon_index['default'], { type: "empty", testId: testId })));
    }
    if (starState === exports.StarState.HALF_FILLED) {
        return (React__default['default'].createElement("div", tslib_es6.__assign({ "data-testid": testId + "_" + exports.StarState.HALF_FILLED }, starProps),
            React__default['default'].createElement(Icons_StarIcon_index['default'], { type: "half", testId: testId })));
    }
    return (React__default['default'].createElement("div", tslib_es6.__assign({ "data-testid": testId + "_" + exports.StarState.FILLED }, starProps),
        React__default['default'].createElement(Icons_StarIcon_index['default'], { type: "full", testId: testId })));
};
var Rating = React__default['default'].forwardRef(function (_a, ref) {
    var className = _a.className, _b = _a.allowEdit, allowEdit = _b === void 0 ? false : _b, rating = _a.rating, onRatingChange = _a.onRatingChange, _c = _a.starSize, starSize = _c === void 0 ? 15 : _c, _d = _a.testId, testId = _d === void 0 ? 'rating' : _d;
    var _e = React.useState(rating), appliedRating = _e[0], setRating = _e[1];
    var mouseOver = function (starposition) {
        if (allowEdit) {
            setRating(starposition);
        }
    };
    var onClick = function (starposition) {
        if (allowEdit && onRatingChange) {
            onRatingChange(starposition);
        }
    };
    var mouseLeave = function () {
        if (allowEdit && onRatingChange) {
            setRating(rating);
        }
    };
    var determineStarState = function (index) {
        var score = roundScore(appliedRating);
        if (index - score === 0.5) {
            return exports.StarState.HALF_FILLED;
        }
        if (score >= index) {
            return exports.StarState.FILLED;
        }
        return exports.StarState.EMPTY;
    };
    return (React__default['default'].createElement(StarsWrapper, { "data-type": [allowEdit ? 'editable' : 'presentational'], className: className, starSize: starSize, ref: ref }, [1, 2, 3, 4, 5].map(function (value, index) { return (React__default['default'].createElement(Star, { testId: testId, key: value, starState: determineStarState(index + 1), onMouseOver: function () { return mouseOver(index + 1); }, onFocus: function () { return mouseOver(index + 1); }, onMouseLeave: mouseLeave, onClick: function () { return onClick(index + 1); } })); })));
});
Rating.displayName = 'Rating';
var templateObject_1, templateObject_2;

exports.Star = Star;
exports.default = Rating;
exports.roundScore = roundScore;
//# sourceMappingURL=index.js.map
